import axiosInstance from './axiosInstance';

function downloadBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export const privacyApi = {
  exportMyData: async (): Promise<void> => {
    const response = await axiosInstance.get('/privacy/export/me', {
      responseType: 'blob',
    });
    downloadBlob(response.data, `my-data-export.json`);
  },

  exportWorkspaceData: async (): Promise<void> => {
    const response = await axiosInstance.get('/privacy/export/workspace', {
      responseType: 'blob',
    });
    downloadBlob(response.data, `workspace-export.json`);
  },

  deleteMyAccount: async (payload: { password: string; confirmEmail: string }): Promise<void> => {
    await axiosInstance.delete('/privacy/account', { data: payload });
  },

  deleteWorkspace: async (payload: {
    password: string;
    confirmWorkspaceName: string;
  }): Promise<void> => {
    await axiosInstance.delete('/privacy/workspace', { data: payload });
  },
};
